import React, { useContext } from 'react';
import PropType from 'prop-types';
import { Config, I18n } from '@deporvillage/utils-library-component';

import styles from './MyFavourites.module.scss';

const MyFavourites = ({ favorites, logged }) => {

    const { url } = useContext(Config);

    const handleClick = (e) => {
        if (!logged) {
            e.preventDefault();
            /* eslint-disable-next-line no-undef*/
            window.dispatchEvent(new CustomEvent('wishlist:click', { detail: { redirect: `${ url }/wishlist` } }));
        }
    };

    return (
        <div className={ styles['my-favourites-component'] }>
            <a className={ `${ styles['favourite-icon'] } ${ favorites ? '' : styles['empty'] }` }
               data-testid='favourite-icon'
               rel='nofollow'
               onClick={ handleClick }
               href={ `${ url }/wishlist` }
            >
                <span className={`icon ${styles['icon'] } icon-favorite`}>
                    { !isNaN(favorites) ? (
                        <span className={ styles['icon-badge'] } data-testid='favorites-items-count'>
                            { favorites }
                        </span>
                    ) : null }
                </span>
                <span className={ styles['favorites-icon-text'] }>
                    <I18n>header.actions.my_wishlist</I18n>
                </span>
            </a>
        </div>
    );
};

MyFavourites.propTypes = {
    favorites: PropType.number,
    logged: PropType.bool,
};

export default MyFavourites;
